import { css } from "@emotion/react";

import {
  BREAKPOINTS,
  COLORS,
  FLEX,
  HELPERS,
  SPACES,
  MIN_HEIGHT,
  VARS,
  STYLES
} from "styles-js";

export const modal = css`
  .ui.modal {
    position: absolute;
    display: none;
    z-index: 1001;
    text-align: left;
    background: #fff;
    border: none;
    box-shadow: 1px 3px 3px 0 rgba(0, 0, 0, 0.2),
      1px 3px 15px 2px rgba(0, 0, 0, 0.2);
    -webkit-transform-origin: 50% 25%;
    transform-origin: 50% 25%;
    -webkit-box-flex: 0;
    flex: 0 0 auto;
    border-radius: 0;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
    will-change: top, left, margin, transform, opacity;
    border-radius: 2px;
    scroll-behavior: auto;
    ${HELPERS.media.smallerThan.md} {
      &.bottom-on-mobile {
        margin: -10px !important;
        width: 100% !important;
        bottom: 0 !important;
        height: 80vh !important;
        max-height: 80vh !important;
      }
    }
  }

  .ui.modal > i.icon.close + div:nth-of-type(1) {
    padding-top: 20px;
  }

  .ui.modal > .icon:first-of-type + *,
  .ui.modal > :first-of-type:not(.icon) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .ui.modal > :last-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .ui.modal > .close {
    cursor: pointer;
    position: absolute;
    top: -2.5rem;
    right: -2.5rem;
    z-index: 1;
    opacity: 0.8;
    font-size: 1.25em;
    color: #fff;
    width: 36px;
    height: 36px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${COLORS.paleGrey};
    &:after {
      content: "\u2716";
      font-style: normal;
      color: black;
    }
    opacity: 0.6;
    &:hover {
      opacity: 1;
    }
  }
  .ui.modal > .close:hover {
    opacity: 1;
  }
  .ui.modal.no-close-icon > .close {
    display: none !important;
  }
  .ui.modal > .header {
    display: block;
    margin: 0;
    padding: 20px;
    box-shadow: none;
    color: rgba(0, 0, 0, 0.85);
    font-weight: ${VARS.font.bold};
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 16px;
    color: ${COLORS.battleshipGrey};
  }
  .ui.modal > .content {
    display: block;
    width: 100%;
    font-size: 1em;
    line-height: 1.4;
    padding: 1.5rem;
    flex: 1 1 auto;
  }
  .ui.modal > .image.content {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
  }
  .ui.modal > .content > .image {
    display: block;
    -webkit-box-flex: 0;
    flex: 0 1 auto;
    width: "";
    align-self: top;
  }
  .ui.modal > [class*="top aligned"] {
    align-self: top;
  }
  .ui.modal > [class*="middle aligned"] {
    align-self: middle;
  }
  .ui.modal > [class*="stretched"] {
    align-self: stretch;
  }
  .ui.modal > .content > .description {
    display: block;
    -webkit-box-flex: 1;
    flex: 1 0 auto;
    min-width: 0;
    align-self: top;
  }
  .ui.modal > .content > .icon + .description,
  .ui.modal > .content > .image + .description {
    -webkit-box-flex: 0;
    flex: 0 1 auto;
    min-width: "";
    width: auto;
    padding-left: 2em;
  }
  .ui.modal > .content > .image > i.icon {
    margin: 0;
    opacity: 1;
    width: auto;
    line-height: 1;
    font-size: 8rem;
  }
  .ui.modal > .actions {
    background: #f9fafb;
    padding: 1rem 1rem;
    border-top: 1px solid rgba(34, 36, 38, 0.3);
    text-align: right;
  }
  .ui.modal .actions > .button {
    margin-left: 0.75em;
  }
  @media only screen and (max-width: 719px) {
    .ui.modal {
      width: 95%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 720px) {
    .ui.modal {
      width: 88%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 992px) {
    .ui.modal {
      width: 850px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1280px) {
    .ui.modal {
      width: 900px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1440px) {
    .ui.modal {
      width: 950px;
      margin: 0;
    }
  }
  @media only screen and (max-width: 991px) {
    .ui.modal > .header {
      padding-right: 2.25rem;
    }
    .ui.modal > .close {
      top: 1.0535rem;
      right: 1rem;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  @media only screen and (max-width: 719px) {
    .ui.modal > .close {
      top: 0.5rem !important;
      right: 0.5rem !important;
    }
    .ui.modal .image.content {
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      flex-direction: column;
    }
    .ui.modal .content > .image {
      display: block;
      max-width: 100%;
      margin: 0 auto !important;
      text-align: center;
      padding: 0 0 1rem !important;
    }
    .ui.modal > .content > .image > i.icon {
      font-size: 5rem;
      text-align: center;
    }
    .ui.modal .content > .description {
      display: block;
      width: 100% !important;
      margin: 0 !important;
      padding: 1rem 0 !important;
      box-shadow: none;
    }
    .ui.modal > .actions {
      padding: 1rem 1rem 0 !important;
    }
    .ui.modal .actions > .button,
    .ui.modal .actions > .buttons {
      margin-bottom: 1rem;
    }
  }
  .ui.inverted.dimmer > .ui.modal {
    box-shadow: 1px 3px 10px 2px rgba(0, 0, 0, 0.2);
  }
  .ui.basic.modal {
    background-color: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none !important;
    color: #fff;
  }
  .ui.basic.modal > .actions,
  .ui.basic.modal > .content,
  .ui.basic.modal > .header {
    background-color: transparent;
  }
  .ui.basic.modal > .header {
    color: #fff;
  }
  .ui.basic.modal > .close {
    top: 1rem;
    right: 1.5rem;
  }
  .ui.inverted.dimmer > .basic.modal {
    color: rgba(0, 0, 0, 0.85);
  }
  .ui.inverted.dimmer > .ui.basic.modal > .header {
    color: rgba(0, 0, 0, 0.85);
  }
  .ui.legacy.modal,
  .ui.legacy.page.dimmer > .ui.modal {
    top: 50%;
    left: 50%;
  }
  .ui.legacy.page.dimmer > .ui.scrolling.modal,
  .ui.page.dimmer > .ui.scrolling.legacy.modal,
  .ui.top.aligned.dimmer > .ui.legacy.modal,
  .ui.top.aligned.legacy.page.dimmer > .ui.modal {
    top: auto;
  }
  @media only screen and (max-width: 991px) {
    .ui.basic.modal > .close {
      color: #fff;
    }
  }
  .ui.loading.modal {
    display: block;
    visibility: hidden;
    z-index: -1;
  }
  .ui.active.modal {
    display: block;
  }
  .modals.dimmer[class*="top aligned"] .modal {
    margin: 5vh auto;
  }
  @media only screen and (max-width: 719px) {
    .modals.dimmer[class*="top aligned"] .modal {
      margin: 1rem auto;
    }
  }
  .legacy.modals.dimmer[class*="top aligned"] {
    padding-top: 5vh;
  }
  @media only screen and (max-width: 719px) {
    .legacy.modals.dimmer[class*="top aligned"] {
      padding-top: 1rem;
    }
  }
  .scrolling.dimmable.dimmed {
    overflow: hidden;
  }
  .scrolling.dimmable > .dimmer {
    -webkit-box-pack: start;
    justify-content: flex-start;
  }
  .scrolling.dimmable.dimmed > .dimmer {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .scrolling.dimmable > .dimmer {
    position: fixed;
  }
  .modals.dimmer .ui.scrolling.modal {
    margin: 1rem auto;
  }
  .scrolling.undetached.dimmable.dimmed {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .scrolling.undetached.dimmable.dimmed > .dimmer {
    overflow: hidden;
  }
  .scrolling.undetached.dimmable .ui.scrolling.modal {
    position: absolute;
    left: 50%;
    margin-top: 1rem !important;
  }
  .ui.modal .scrolling.content {
    max-height: calc(90vh - 10em);
    overflow: auto;
  }
  .ui.fullscreen.modal {
    width: 95% !important;
    margin: 1em auto;
  }
  .ui.fullscreen.modal > .header {
    padding-right: 2.25rem;
  }
  .ui.fullscreen.modal > .close {
    top: 1.0535rem;
    right: 1rem;
    color: rgba(0, 0, 0, 0.85);
  }
  .ui.modal {
    font-size: 1rem;
  }
  .ui.mini.modal > .header:not(.ui) {
    font-size: 1.3em;
  }
  @media only screen and (max-width: 719px) {
    .ui.mini.modal {
      width: 95%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 720px) {
    .ui.mini.modal {
      width: 35.2%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 992px) {
    .ui.mini.modal {
      width: 340px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1280px) {
    .ui.mini.modal {
      width: 360px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1440px) {
    .ui.mini.modal {
      width: 380px;
      margin: 0;
    }
  }
  .ui.small.modal > .header:not(.ui) {
    font-size: 1.3em;
  }
  @media only screen and (max-width: 719px) {
    .ui.tiny.modal {
      width: 95%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 720px) {
    .ui.tiny.modal {
      width: 52.8%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 992px) {
    .ui.tiny.modal {
      width: 510px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1280px) {
    .ui.tiny.modal {
      width: 540px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1440px) {
    .ui.tiny.modal {
      width: 570px;
      margin: 0;
    }
  }
  .ui.small.modal > .header:not(.ui) {
    font-size: 1.3em;
  }
  @media only screen and (max-width: 719px) {
    .ui.small.modal {
      width: 95%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 720px) {
    .ui.small.modal {
      width: 70.4%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 992px) {
    .ui.small.modal {
      width: 680px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1280px) {
    .ui.small.modal {
      width: 720px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1440px) {
    .ui.small.modal {
      width: 760px;
      margin: 0;
    }
  }
  .ui.large.modal > .header {
    font-size: 1.6em;
  }
  @media only screen and (max-width: 719px) {
    .ui.large.modal {
      width: 95%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 720px) {
    .ui.large.modal {
      width: 88%;
      margin: 0;
    }
  }
  @media only screen and (min-width: 992px) {
    .ui.large.modal {
      width: 1020px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1280px) {
    .ui.large.modal {
      width: 1080px;
      margin: 0;
    }
  }
  @media only screen and (min-width: 1440px) {
    .ui.large.modal {
      width: 1140px;
      margin: 0;
    }
  }
`;

export const dimmer = css`
  .dimmable:not(body) {
    position: relative;
  }
  .ui.dimmer {
    display: none;
    position: absolute;
    top: 0 !important;
    left: 0 !important;
    width: 100%;
    height: 100%;
    text-align: center;
    vertical-align: middle;
    padding: 1em;
    background-color: rgba(0, 0, 0, 0.65);
    opacity: 0;
    line-height: 1;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation-duration: 0.5s;
    animation-duration: 0.5s;
    -webkit-transition: background-color 0.5s linear;
    transition: background-color 0.5s linear;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    will-change: opacity;
    z-index: 999;
  }
  .ui.dimmer > .content {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
    color: #fff;
  }
  .ui.segment > .ui.dimmer {
    border-radius: inherit !important;
  }
  .ui.dimmer:not(.inverted)::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
  }
  .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.25);
  }
  .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(255, 255, 255, 0.15);
  }
  .ui.dimmer:not(.inverted)::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.35);
  }
  .animating.dimmable:not(body),
  .dimmed.dimmable:not(body) {
    overflow: hidden;
  }
  .dimmed.dimmable > .ui.animating.dimmer,
  .dimmed.dimmable > .ui.visible.dimmer,
  .ui.active.dimmer {
    display: -webkit-box;
    display: flex;
    opacity: 1;
  }
  .ui.disabled.dimmer {
    width: 0 !important;
    height: 0 !important;
  }
  .dimmed.dimmable > .ui.animating.legacy.dimmer,
  .dimmed.dimmable > .ui.visible.legacy.dimmer,
  .ui.active.legacy.dimmer {
    display: block;
  }
  .ui[class*="top aligned"].dimmer {
    -webkit-box-pack: start;
    justify-content: flex-start;
  }
  .ui[class*="bottom aligned"].dimmer {
    -webkit-box-pack: end;
    justify-content: flex-end;
  }
  .ui.page.dimmer {
    position: fixed;
    -webkit-transform-style: "";
    transform-style: "";
    -webkit-perspective: 2000px;
    perspective: 2000px;
    -webkit-transform-origin: center center;
    transform-origin: center center;
  }
  body.animating.in.dimmable,
  body.dimmed.dimmable {
  }
  body.dimmable > .dimmer {
    position: fixed;
  }
  .blurring.dimmable > :not(.dimmer) {
    -webkit-filter: blur(0) grayscale(0);
    filter: blur(0) grayscale(0);
    -webkit-transition: 0.8s -webkit-filter ease;
    transition: 0.8s -webkit-filter ease;
    transition: 0.8s filter ease;
    transition: 0.8s filter ease, 0.8s -webkit-filter ease;
  }
  .blurring.dimmed.dimmable > :not(.dimmer) {
    -webkit-filter: blur(5px) grayscale(0.7);
    filter: blur(5px) grayscale(0.7);
  }
  .blurring.dimmable > .dimmer {
    background-color: rgba(0, 0, 0, 0.6);
  }
  .blurring.dimmable > .inverted.dimmer {
    background-color: rgba(255, 255, 255, 0.6);
  }
  .ui.dimmer > .top.aligned.content > * {
    vertical-align: top;
  }
  .ui.dimmer > .bottom.aligned.content > * {
    vertical-align: bottom;
  }
  .ui.inverted.dimmer {
    background-color: rgba(255, 255, 255, 0.85);
  }
  .ui.inverted.dimmer > .content > * {
    color: #fff;
  }
  .ui.simple.dimmer {
    display: block;
    overflow: hidden;
    opacity: 1;
    width: 0%;
    height: 0%;
    z-index: -100;
    background-color: rgba(0, 0, 0, 0);
  }
  .dimmed.dimmable > .ui.simple.dimmer {
    overflow: visible;
    opacity: 1;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.85);
    z-index: 1;
  }
  .ui.simple.inverted.dimmer {
    background-color: rgba(255, 255, 255, 0);
  }
  .dimmed.dimmable > .ui.simple.inverted.dimmer {
    background-color: rgba(255, 255, 255, 0.85);
  }
  .ui.dimmer.transition.visible {
    display: -webkit-box !important;
    display: flex !important;
  }
`;

export const popup = css`
  .ui.popup {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    min-width: -webkit-min-content;
    min-width: -moz-min-content;
    min-width: min-content;
    z-index: 1900;
    border: 1px solid #d4d4d5;
    line-height: 1.4285em;
    max-width: 250px;
    background: #fff;
    padding: 0.833em 1em;
    font-weight: 400;
    font-style: normal;
    color: rgba(0, 0, 0, 0.85);
    border-radius: 0;
    box-shadow: 0 4px 4px 0 rgba(34, 36, 38, 0.12),
      0 4px 7px 2px rgba(34, 36, 38, 0.15);
  }
  .ui.popup > .header {
    padding: 0;
    font-size: 1.14285714em;
    line-height: 1.2;
    font-weight: 700;
  }
  .ui.popup > .header + .content {
    padding-top: 0.5em;
  }
  .ui.popup:before {
    position: absolute;
    content: "";
    width: 0.71428571em;
    height: 0.71428571em;
    background: #fff;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    z-index: 2;
    box-shadow: 1px 1px 0 0 #bababc;
  }
  [data-tooltip] {
    position: relative;
  }
  [data-tooltip]:before {
    pointer-events: none;
    position: absolute;
    content: "";
    font-size: 1rem;
    width: 0.71428571em;
    height: 0.71428571em;
    background: #fff;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    z-index: 2;
    box-shadow: 1px 1px 0 0 #bababc;
  }
  [data-tooltip]:after {
    pointer-events: none;
    content: attr(data-tooltip);
    position: absolute;
    text-transform: none;
    text-align: left;
    white-space: nowrap;
    font-size: 1rem;
    border: 1px solid #d4d4d5;
    line-height: 1.4285em;
    max-width: none;
    background: #fff;
    padding: 0.833em 1em;
    font-weight: 400;
    font-style: normal;
    color: rgba(0, 0, 0, 0.85);
    border-radius: 0;
    box-shadow: 0 4px 4px 0 rgba(34, 36, 38, 0.12),
      0 4px 7px 2px rgba(34, 36, 38, 0.15);
    z-index: 1;
  }
  [data-tooltip]:not([data-position]):before {
    top: auto;
    right: auto;
    bottom: 100%;
    left: 50%;
    background: #fff;
    margin-left: -0.07142857rem;
    margin-bottom: 0.14285714rem;
  }
  [data-tooltip]:not([data-position]):after {
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: 100%;
    margin-bottom: 0.5em;
  }
  [data-tooltip]:after,
  [data-tooltip]:before {
    pointer-events: none;
    visibility: hidden;
  }
  [data-tooltip]:before {
    opacity: 0;
    -webkit-transform: rotate(45deg) scale(0) !important;
    transform: rotate(45deg) scale(0) !important;
    -webkit-transform-origin: center top;
    transform-origin: center top;
    -webkit-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  [data-tooltip]:after {
    opacity: 1;
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
    -webkit-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  [data-tooltip]:hover:after,
  [data-tooltip]:hover:before {
    visibility: visible;
    pointer-events: auto;
  }
  [data-tooltip]:hover:before {
    -webkit-transform: rotate(45deg) scale(1) !important;
    transform: rotate(45deg) scale(1) !important;
    opacity: 1;
  }
  [data-tooltip]:after,
  [data-tooltip][data-position="bottom center"]:after,
  [data-tooltip][data-position="top center"]:after {
    -webkit-transform: translateX(-50%) scale(0) !important;
    transform: translateX(-50%) scale(0) !important;
  }
  [data-tooltip]:hover:after,
  [data-tooltip][data-position="bottom center"]:hover:after {
    -webkit-transform: translateX(-50%) scale(1) !important;
    transform: translateX(-50%) scale(1) !important;
  }
  [data-tooltip][data-position="left center"]:after,
  [data-tooltip][data-position="right center"]:after {
    -webkit-transform: translateY(-50%) scale(0) !important;
    transform: translateY(-50%) scale(0) !important;
  }
  [data-tooltip][data-position="left center"]:hover:after,
  [data-tooltip][data-position="right center"]:hover:after {
    -webkit-transform: translateY(-50%) scale(1) !important;
    transform: translateY(-50%) scale(1) !important;
  }
  [data-tooltip][data-position="bottom left"]:after,
  [data-tooltip][data-position="bottom right"]:after,
  [data-tooltip][data-position="top left"]:after,
  [data-tooltip][data-position="top right"]:after {
    -webkit-transform: scale(0) !important;
    transform: scale(0) !important;
  }
  [data-tooltip][data-position="bottom left"]:hover:after,
  [data-tooltip][data-position="bottom right"]:hover:after,
  [data-tooltip][data-position="top left"]:hover:after,
  [data-tooltip][data-position="top right"]:hover:after {
    -webkit-transform: scale(1) !important;
    transform: scale(1) !important;
  }
  [data-tooltip][data-inverted]:before {
    box-shadow: none !important;
  }
  [data-tooltip][data-inverted]:before {
    background: #1b1c1d;
  }
  [data-tooltip][data-inverted]:after {
    background: #1b1c1d;
    color: #fff;
    border: none;
    box-shadow: none;
  }
  [data-tooltip][data-inverted]:after .header {
    background-color: none;
    color: #fff;
  }
  [data-position="top center"][data-tooltip]:after {
    top: auto;
    right: auto;
    left: 50%;
    bottom: 100%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    margin-bottom: 0.5em;
  }
  [data-position="top center"][data-tooltip]:before {
    top: auto;
    right: auto;
    bottom: 100%;
    left: 50%;
    background: #fff;
    margin-left: -0.07142857rem;
    margin-bottom: 0.14285714rem;
  }
  [data-position="top left"][data-tooltip]:after {
    top: auto;
    right: auto;
    left: 0;
    bottom: 100%;
    margin-bottom: 0.5em;
  }
  [data-position="top left"][data-tooltip]:before {
    top: auto;
    right: auto;
    bottom: 100%;
    left: 1em;
    margin-left: -0.07142857rem;
    margin-bottom: 0.14285714rem;
  }
  [data-position="top right"][data-tooltip]:after {
    top: auto;
    left: auto;
    right: 0;
    bottom: 100%;
    margin-bottom: 0.5em;
  }
  [data-position="top right"][data-tooltip]:before {
    top: auto;
    left: auto;
    bottom: 100%;
    right: 1em;
    margin-left: -0.07142857rem;
    margin-bottom: 0.14285714rem;
  }
  [data-position="bottom center"][data-tooltip]:after {
    bottom: auto;
    right: auto;
    left: 50%;
    top: 100%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    margin-top: 0.5em;
  }
  [data-position="bottom center"][data-tooltip]:before {
    bottom: auto;
    right: auto;
    top: 100%;
    left: 50%;
    margin-left: -0.07142857rem;
    margin-top: 0.14285714rem;
  }
  [data-position="bottom left"][data-tooltip]:after {
    left: 0;
    top: 100%;
    margin-top: 0.5em;
  }
  [data-position="bottom left"][data-tooltip]:before {
    bottom: auto;
    right: auto;
    top: 100%;
    left: 1em;
    margin-left: -0.07142857rem;
    margin-top: 0.14285714rem;
  }
  [data-position="bottom right"][data-tooltip]:after {
    right: 0;
    top: 100%;
    margin-top: 0.5em;
  }
  [data-position="bottom right"][data-tooltip]:before {
    bottom: auto;
    left: auto;
    top: 100%;
    right: 1em;
    margin-left: -0.14285714rem;
    margin-top: 0.07142857rem;
  }
  [data-position="left center"][data-tooltip]:after {
    right: 100%;
    top: 50%;
    margin-right: 0.5em;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  [data-position="left center"][data-tooltip]:before {
    right: 100%;
    top: 50%;
    margin-top: -0.14285714rem;
    margin-right: -0.07142857rem;
  }
  [data-position="right center"][data-tooltip]:after {
    left: 100%;
    top: 50%;
    margin-left: 0.5em;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  [data-position="right center"][data-tooltip]:before {
    left: 100%;
    top: 50%;
    margin-top: -0.07142857rem;
    margin-left: 0.14285714rem;
  }
  [data-position~="bottom"][data-tooltip]:before {
    background: #fff;
    box-shadow: -1px -1px 0 0 #bababc;
  }
  [data-position="left center"][data-tooltip]:before {
    background: #fff;
    box-shadow: 1px -1px 0 0 #bababc;
  }
  [data-position="right center"][data-tooltip]:before {
    background: #fff;
    box-shadow: -1px 1px 0 0 #bababc;
  }
  [data-position~="top"][data-tooltip]:before {
    background: #fff;
  }
  [data-inverted][data-position~="bottom"][data-tooltip]:before {
    background: #1b1c1d;
    box-shadow: -1px -1px 0 0 #bababc;
  }
  [data-inverted][data-position="left center"][data-tooltip]:before {
    background: #1b1c1d;
    box-shadow: 1px -1px 0 0 #bababc;
  }
  [data-inverted][data-position="right center"][data-tooltip]:before {
    background: #1b1c1d;
    box-shadow: -1px 1px 0 0 #bababc;
  }
  [data-inverted][data-position~="top"][data-tooltip]:before {
    background: #1b1c1d;
  }
  [data-position~="bottom"][data-tooltip]:before {
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
  }
  [data-position~="bottom"][data-tooltip]:after {
    -webkit-transform-origin: center top;
    transform-origin: center top;
  }
  [data-position="left center"][data-tooltip]:before {
    -webkit-transform-origin: top center;
    transform-origin: top center;
  }
  [data-position="left center"][data-tooltip]:after {
    -webkit-transform-origin: right center;
    transform-origin: right center;
  }
  [data-position="right center"][data-tooltip]:before {
    -webkit-transform-origin: right center;
    transform-origin: right center;
  }
  [data-position="right center"][data-tooltip]:after {
    -webkit-transform-origin: left center;
    transform-origin: left center;
  }
  .ui.popup {
    margin: 0;
  }
  .ui.top.popup {
    margin: 0 0 0.71428571em;
  }
  .ui.top.left.popup {
    -webkit-transform-origin: left bottom;
    transform-origin: left bottom;
  }
  .ui.top.center.popup {
    -webkit-transform-origin: center bottom;
    transform-origin: center bottom;
  }
  .ui.top.right.popup {
    -webkit-transform-origin: right bottom;
    transform-origin: right bottom;
  }
  .ui.left.center.popup {
    margin: 0 0.71428571em 0 0;
    -webkit-transform-origin: right 50%;
    transform-origin: right 50%;
  }
  .ui.right.center.popup {
    margin: 0 0 0 0.71428571em;
    -webkit-transform-origin: left 50%;
    transform-origin: left 50%;
  }
  .ui.bottom.popup {
    margin: 0.71428571em 0 0;
  }
  .ui.bottom.left.popup {
    -webkit-transform-origin: left top;
    transform-origin: left top;
  }
  .ui.bottom.center.popup {
    -webkit-transform-origin: center top;
    transform-origin: center top;
  }
  .ui.bottom.right.popup {
    -webkit-transform-origin: right top;
    transform-origin: right top;
  }
  .ui.bottom.center.popup:before {
    margin-left: -0.30714286em;
    top: -0.30714286em;
    left: 50%;
    right: auto;
    bottom: auto;
    box-shadow: -1px -1px 0 0 #bababc;
  }
  .ui.bottom.left.popup {
    margin-left: 0;
  }
  .ui.bottom.left.popup:before {
    top: -0.30714286em;
    left: 1em;
    right: auto;
    bottom: auto;
    margin-left: 0;
    box-shadow: -1px -1px 0 0 #bababc;
  }
  .ui.bottom.right.popup {
    margin-right: 0;
  }
  .ui.bottom.right.popup:before {
    top: -0.30714286em;
    right: 1em;
    bottom: auto;
    left: auto;
    margin-left: 0;
    box-shadow: -1px -1px 0 0 #bababc;
  }
  .ui.top.center.popup:before {
    top: auto;
    right: auto;
    bottom: -0.30714286em;
    left: 50%;
    margin-left: -0.30714286em;
  }
  .ui.top.left.popup {
    margin-left: 0;
  }
  .ui.top.left.popup:before {
    bottom: -0.30714286em;
    left: 1em;
    top: auto;
    right: auto;
    margin-left: 0;
  }
  .ui.top.right.popup {
    margin-right: 0;
  }
  .ui.top.right.popup:before {
    bottom: -0.30714286em;
    right: 1em;
    top: auto;
    left: auto;
    margin-left: 0;
  }
  .ui.left.center.popup:before {
    top: 50%;
    right: -0.30714286em;
    bottom: auto;
    left: auto;
    margin-top: -0.30714286em;
    box-shadow: 1px -1px 0 0 #bababc;
  }
  .ui.right.center.popup:before {
    top: 50%;
    left: -0.30714286em;
    bottom: auto;
    right: auto;
    margin-top: -0.30714286em;
    box-shadow: -1px 1px 0 0 #bababc;
  }
  .ui.bottom.popup:before {
    background: #fff;
  }
  .ui.left.center.popup:before,
  .ui.right.center.popup:before {
    background: #fff;
  }
  .ui.top.popup:before {
    background: #fff;
  }
  .ui.inverted.bottom.popup:before {
    background: #1b1c1d;
  }
  .ui.inverted.left.center.popup:before,
  .ui.inverted.right.center.popup:before {
    background: #1b1c1d;
  }
  .ui.inverted.top.popup:before {
    background: #1b1c1d;
  }
  .ui.popup > .ui.grid:not(.padded) {
    width: calc(100% + 1.75rem);
    margin: -0.7rem -0.875rem;
  }
  .ui.loading.popup {
    display: block;
    visibility: hidden;
    z-index: -1;
  }
  .ui.animating.popup,
  .ui.visible.popup {
    display: block;
  }
  .ui.visible.popup {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }
  .ui.basic.popup:before {
    display: none;
  }
  .ui.wide.popup {
    max-width: 350px;
  }
  .ui[class*="very wide"].popup {
    max-width: 550px;
  }
  @media only screen and (max-width: 719px) {
    .ui.wide.popup,
    .ui[class*="very wide"].popup {
      max-width: 250px;
    }
  }
  .ui.fluid.popup {
    width: 100%;
    max-width: none;
  }
  .ui.inverted.popup {
    background: #1b1c1d;
    color: #fff;
    border: none;
    box-shadow: none;
  }
  .ui.inverted.popup .header {
    background-color: none;
    color: #fff;
  }
  .ui.inverted.popup:before {
    background-color: #1b1c1d;
    box-shadow: none !important;
  }
  .ui.flowing.popup {
    max-width: none;
  }
  .ui.mini.popup {
    font-size: 0.78571429rem;
  }
  .ui.tiny.popup {
    font-size: 0.85714286rem;
  }
  .ui.small.popup {
    font-size: 0.92857143rem;
  }
  .ui.popup {
    font-size: 1rem;
  }
  .ui.large.popup {
    font-size: 1.14285714rem;
  }
  .ui.huge.popup {
    font-size: 1.42857143rem;
  }
`;

export const placeholder = css`
  .ui.placeholder {
    position: static;
    overflow: hidden;
    -webkit-animation: placeholderShimmer 2s linear;
    animation: placeholderShimmer 2s linear;
    -webkit-animation-iteration-count: infinite;
    animation-iteration-count: infinite;
    background-color: #fff;
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      from(rgba(0, 0, 0, 0.08)),
      color-stop(15%, rgba(0, 0, 0, 0.15)),
      color-stop(30%, rgba(0, 0, 0, 0.08))
    );
    background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.08) 0,
      rgba(0, 0, 0, 0.15) 15%,
      rgba(0, 0, 0, 0.08) 30%
    );
    background-size: 1200px 100%;
    max-width: 30rem;
  }
  @-webkit-keyframes placeholderShimmer {
    0% {
      background-position: -1200px 0;
    }
    100% {
      background-position: 1200px 0;
    }
  }
  @keyframes placeholderShimmer {
    0% {
      background-position: -1200px 0;
    }
    100% {
      background-position: 1200px 0;
    }
  }
  .ui.placeholder + .ui.placeholder {
    margin-top: 2rem;
  }
  .ui.placeholder + .ui.placeholder {
    -webkit-animation-delay: 0.15s;
    animation-delay: 0.15s;
  }
  .ui.placeholder + .ui.placeholder + .ui.placeholder {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
  }
  .ui.placeholder + .ui.placeholder + .ui.placeholder + .ui.placeholder {
    -webkit-animation-delay: 0.45s;
    animation-delay: 0.45s;
  }
  .ui.placeholder
    + .ui.placeholder
    + .ui.placeholder
    + .ui.placeholder
    + .ui.placeholder {
    -webkit-animation-delay: 0.6s;
    animation-delay: 0.6s;
  }
  .ui.placeholder,
  .ui.placeholder .image.header:after,
  .ui.placeholder .line,
  .ui.placeholder .line:after,
  .ui.placeholder > :before {
    background-color: #fff;
  }
  .ui.placeholder .image:not(.header):not(.ui) {
    height: 100px;
  }
  .ui.placeholder .square.image:not(.header) {
    height: 0;
    overflow: hidden;
    padding-top: 100%;
  }
  .ui.placeholder .rectangular.image:not(.header) {
    height: 0;
    overflow: hidden;
    padding-top: 75%;
  }
  .ui.placeholder .line {
    position: relative;
    height: 0.85714286em;
  }
  .ui.placeholder .line:after,
  .ui.placeholder .line:before {
    top: 100%;
    position: absolute;
    content: "";
    background-color: inherit;
  }
  .ui.placeholder .line:before {
    left: 0;
  }
  .ui.placeholder .line:after {
    right: 0;
  }
  .ui.placeholder .line {
    margin-bottom: 0.5em;
  }
  .ui.placeholder .line:after,
  .ui.placeholder .line:before {
    height: 0.5em;
  }
  .ui.placeholder .line:not(:first-of-type) {
    margin-top: 0.5em;
  }
  .ui.placeholder .header {
    position: relative;
    overflow: hidden;
  }
  .ui.placeholder .line:nth-of-type(1):after {
    width: 0%;
  }
  .ui.placeholder .line:nth-of-type(2):after {
    width: 50%;
  }
  .ui.placeholder .line:nth-of-type(3):after {
    width: 10%;
  }
  .ui.placeholder .line:nth-of-type(4):after {
    width: 35%;
  }
  .ui.placeholder .line:nth-of-type(5):after {
    width: 65%;
  }
  .ui.placeholder .header .line {
    margin-bottom: 0.64285714em;
  }
  .ui.placeholder .header .line:after,
  .ui.placeholder .header .line:before {
    height: 0.64285714em;
  }
  .ui.placeholder .header .line:not(:first-of-type) {
    margin-top: 0.64285714em;
  }
  .ui.placeholder .header .line:after {
    width: 20%;
  }
  .ui.placeholder .header .line:nth-of-type(2):after {
    width: 60%;
  }
  .ui.placeholder .image.header .line {
    margin-left: 3em;
  }
  .ui.placeholder .image.header .line:before {
    width: 0.71428571rem;
  }
  .ui.placeholder .image.header:after {
    display: block;
    height: 0.85714286em;
    content: "";
    margin-left: 3em;
  }
  .ui.placeholder .header .line:first-of-type,
  .ui.placeholder .image .line:first-of-type,
  .ui.placeholder .paragraph .line:first-of-type {
    height: 0.01px;
  }
  .ui.placeholder .header:not(:first-of-type):before,
  .ui.placeholder .image:not(:first-of-type):before,
  .ui.placeholder .paragraph:not(:first-of-type):before {
    height: 1.42857143em;
    content: "";
    display: block;
  }
  .ui.inverted.placeholder {
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      from(rgba(255, 255, 255, 0.08)),
      color-stop(15%, rgba(255, 255, 255, 0.14)),
      color-stop(30%, rgba(255, 255, 255, 0.08))
    );
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.08) 0,
      rgba(255, 255, 255, 0.14) 15%,
      rgba(255, 255, 255, 0.08) 30%
    );
  }
  .ui.inverted.placeholder,
  .ui.inverted.placeholder .image.header:after,
  .ui.inverted.placeholder .line,
  .ui.inverted.placeholder .line:after,
  .ui.inverted.placeholder > :before {
    background-color: #1b1c1d;
  }
  .ui.placeholder .full.line.line.line:after {
    width: 0%;
  }
  .ui.placeholder .very.long.line.line.line:after {
    width: 10%;
  }
  .ui.placeholder .long.line.line.line:after {
    width: 35%;
  }
  .ui.placeholder .medium.line.line.line:after {
    width: 50%;
  }
  .ui.placeholder .short.line.line.line:after {
    width: 65%;
  }
  .ui.placeholder .very.short.line.line.line:after {
    width: 80%;
  }
  .ui.fluid.placeholder {
    max-width: none;
  }
`;

export const accordion = css`
.ui.accordion,
.ui.accordion .accordion {
  max-width: 100%;
}
.ui.accordion .accordion {
  margin: 1em 0em 0em;
  padding: 0em;
}

.ui.accordion .title,
.ui.accordion .accordion .title {
  cursor: pointer;
}

.ui.accordion .title:not(.ui) {
  padding: 0.5em 0em;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.85);
}

.ui.accordion .title ~ .content,
.ui.accordion .accordion .title ~ .content {
  display: none;
}

.ui.accordion:not(.styled) .title ~ .content:not(.ui),
.ui.accordion:not(.styled) .accordion .title ~ .content:not(.ui) {
  margin: '';
  padding: 0.5em 0em 1em;
}
.ui.accordion:not(.styled) .title ~ .content:not(.ui):last-child {
  padding-bottom: 0em;
}

.ui.accordion .title .dropdown.icon,
.ui.accordion .accordion .title .dropdown.icon {
  display: inline-block;
  float: right;
  opacity: 1;
  width: 1.25em;
  height: 1em;
  margin: 0em 0.25rem 0em 0rem;
  padding: 0em;
  font-size: 1em;
  transition: transform 0.1s ease, opacity 0.1s ease;
  vertical-align: baseline;
  transform: none;
}

.ui.accordion.menu .item .title {
  display: block;
  padding: 0em;
}
.ui.accordion.menu .item .title > .dropdown.icon {
  float: right;
  margin: 0.21425em 0em 0em 1em;
  transform: rotate(180deg);
}

.ui.accordion .ui.header .dropdown.icon {
  font-size: 1em;
  margin: 0em 0.25rem 0em 0rem;
}

.ui.accordion .active.title .dropdown.icon,
.ui.accordion .accordion .active.title .dropdown.icon {
  transform: rotate(90deg);
}
.ui.accordion.menu .item .active.title > .dropdown.icon {
  transform: rotate(90deg);
}

.ui.styled.accordion {
  width: 600px;
}
.ui.styled.accordion,
.ui.styled.accordion .accordion {
  border-radius: 0;
  background: #FFFFFF;
  border-radius: 16px;
  border: solid 1px #eae8e8;
}
.ui.styled.accordion .title,
.ui.styled.accordion .accordion .title {
  margin: 0em;
  padding: 0.75em 1em;
  color: ${COLORS.lightRoyalBlue}
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: 0.2px;
  border-top: 1px solid rgba(34, 36, 38, 0.3);
  transition: background 0.1s ease, color 0.1s ease;
}

.ui.styled.accordion .content,
.ui.styled.accordion .accordion .content {
  margin: 0em;
  padding: 0.5em 1em 1.5em;
}
.ui.styled.accordion .accordion .content {
  padding: 0em;
  padding: 0.5em 1em 1.5em;
}

.ui.styled.accordion .title:hover,
.ui.styled.accordion .active.title,
.ui.styled.accordion .accordion .title:hover,
.ui.styled.accordion .accordion .active.title {
  background: transparent;
  color: ${COLORS.lightRoyalBlue};
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: 0.2px;
}
.ui.styled.accordion .accordion .title:hover,
.ui.styled.accordion .accordion .active.title {
  background: transparent;
  color: ${COLORS.lightRoyalBlue};
}

.ui.styled.accordion .active.title {
  background: transparent;
  color: ${COLORS.lightRoyalBlue};
}
.ui.styled.accordion .accordion .active.title {
  background: transparent;
  color: ${COLORS.lightRoyalBlue};
}

.ui.accordion .active.content,
.ui.accordion .accordion .active.content {
  display: block;
}

.ui.fluid.accordion,
.ui.fluid.accordion .accordion {
  width: 100%;
}

.ui.inverted.accordion .title:not(.ui) {
  color: ${COLORS.lightRoyalBlue};
}

@font-face {
  font-family: 'Accordion';
  src: url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfOIKAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zryj6HgAAAFwAAAAyGhlYWT/0IhHAAACOAAAADZoaGVhApkB5wAAAnAAAAAkaG10eAJuABIAAAKUAAAAGGxvY2EAjABWAAACrAAAAA5tYXhwAAgAFgAAArwAAAAgbmFtZfC1n04AAALcAAABPHBvc3QAAwAAAAAEGAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQASAEkAtwFuABMAADc0PwE2FzYXFh0BFAcGJwYvASY1EgaABQgHBQYGBQcIBYAG2wcGfwcBAQcECf8IBAcBAQd/BgYAAAAAAQAAAEkApQFuABMAADcRNDc2MzIfARYVFA8BBiMiJyY1AAUGBwgFgAYGgAUIBwYFWwEACAUGBoAFCAcFgAYGBQcAAAABAAAAAQAAqWYls18PPPUACwIAAAAAAM/9o+4AAAAAz/2j7gAAAAAAtwFuAAAACAACAAAAAAAAAAEAAAHg/+AAAAIAAAAAAAC3AAEAAAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAQAAAAC3ABIAtwAAAAAAAAAKABQAHgBCAGQAAAABAAAABgAUAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype'), url(data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAASwAAoAAAAABGgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAS0AAAEtFpovuE9TLzIAAAIkAAAAYAAAAGAIIweQY21hcAAAAoQAAABMAAAATA984gpnYXNwAAAC0AAAAAgAAAAIAAAAEGhlYWQAAALYAAAANgAAADb/0IhHaGhlYQAAAxAAAAAkAAAAJAKZAedobXR4AAADNAAAABgAAAAYAm4AEm1heHAAAANMAAAABgAAAAYABlAAbmFtZQAAA1QAAAE8AAABPPC1n05wb3N0AAAEkAAAACAAAAAgAAMAAAEABAQAAQEBB3JhdGluZwABAgABADr4HAL4GwP4GAQeCgAZU/+Lix4KABlT/4uLDAeLa/iU+HQFHQAAAHkPHQAAAH4RHQAAAAkdAAABJBIABwEBBw0PERQZHnJhdGluZ3JhdGluZ3UwdTF1MjB1RjBEOXVGMERBAAACAYkABAAGAQEEBwoNVp38lA78lA78lA77lA773Z33bxWLkI2Qj44I9xT3FAWOj5CNkIuQi4+JjoePiI2Gi4YIi/uUBYuGiYeHiIiHh4mGi4aLho2Ijwj7FPcUBYeOiY+LkAgO+92L5hWL95QFi5CNkI6Oj4+PjZCLkIuQiY6HCPcU+xQFj4iNhouGi4aJh4eICPsU+xQFiIeGiYaLhouHjYePiI6Jj4uQCA74lBT4lBWLDAoAAAAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAEAADfYOJZfDzz1AAsCAAAAAADP/aPuAAAAAM/9o+4AAAAAALcBbgAAAAgAAgAAAAAAAAABAAAB4P/gAAACAAAAAAAAtwABAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAEAAAAAtwASALcAAAAAUAAABgAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('woff');
  font-weight: normal;
  font-style: normal;
}
.ui.accordion .title .dropdown.icon,
.ui.accordion .accordion .title .dropdown.icon {
  font-family: Accordion;
  line-height: 1;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  font-weight: normal;
  font-style: normal;
  text-align: center;
}
.ui.accordion .title .dropdown.icon:before,
.ui.accordion .accordion .title .dropdown.icon:before {
  content: '\f0da';
}`;

export const checkbox = css`
  .ui.checkbox {
    position: relative;
    display: inline-block;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    outline: none;
    vertical-align: baseline;
    font-style: normal;
    min-height: 17px;
    font-size: 1rem;
    line-height: 17px;
    min-width: 17px;
  }
  /* HTML Checkbox */
  .ui.checkbox input[type="checkbox"],
  .ui.checkbox input[type="radio"] {
    cursor: pointer;
    position: absolute;
    top: 0px;
    left: 0px;
    opacity: 0 !important;
    outline: none;
    z-index: 3;
    width: 17px;
    height: 17px;
  }
  /*--------------
      Box
---------------*/
  .ui.checkbox .box,
  .ui.checkbox label {
    cursor: auto;
    position: relative;
    display: block;
    padding-left: 1.85714em;
    outline: none;
    font-size: 1em;
  }
  .ui.checkbox .box:before,
  .ui.checkbox label:before {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 17px;
    height: 17px;
    content: "";
    background: #ffffff;
    border-radius: 0.21428571rem;
    transition: border 0.1s ease, opacity 0.1s ease, box-shadow 0.1s ease,
      -webkit-transform 0.1s ease;
    transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease,
      box-shadow 0.1s ease;
    transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease,
      box-shadow 0.1s ease, -webkit-transform 0.1s ease;
    border: 1px solid #d4d4d5;
  }
  /*--------------
    Checkmark
---------------*/
  .ui.checkbox .box:after,
  .ui.checkbox label:after {
    position: absolute;
    font-size: 14px;
    top: 0px;
    left: 0px;
    width: 17px;
    height: 17px;
    text-align: center;
    opacity: 0;
    color: rgba(0, 0, 0, 0.85);
    transition: border 0.1s ease, opacity 0.1s ease, box-shadow 0.1s ease,
      -webkit-transform 0.1s ease;
    transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease,
      box-shadow 0.1s ease;
    transition: border 0.1s ease, opacity 0.1s ease, transform 0.1s ease,
      box-shadow 0.1s ease, -webkit-transform 0.1s ease;
  }
  /*--------------
      Label
---------------*/
  /* Inside */
  .ui.checkbox label,
  .ui.checkbox + label {
    color: rgba(0, 0, 0, 0.85);
    transition: color 0.1s ease;
  }
  /* Outside */
  .ui.checkbox + label {
    vertical-align: middle;
  }
  /*******************************
           States
*******************************/
  /*--------------
      Hover
---------------*/
  .ui.checkbox .box:hover::before,
  .ui.checkbox label:hover::before {
    background: #ffffff;
    border-color: rgba(34, 36, 38, 0.45);
  }
  .ui.checkbox label:hover,
  .ui.checkbox + label:hover {
    color: rgba(0, 0, 0, 0.8);
  }
  /*--------------
      Down
---------------*/
  .ui.checkbox .box:active::before,
  .ui.checkbox label:active::before {
    background: #f9fafb;
    border-color: rgba(34, 36, 38, 0.45);
  }
  .ui.checkbox .box:active::after,
  .ui.checkbox label:active::after {
    color: rgba(0, 0, 0, 0.95);
  }
  .ui.checkbox input:active ~ label {
    color: rgba(0, 0, 0, 0.95);
  }
  /*--------------
     Focus
---------------*/
  .ui.checkbox input:focus ~ .box:before,
  .ui.checkbox input:focus ~ label:before {
    background: #ffffff;
    border-color: #96c8da;
  }
  .ui.checkbox input:focus ~ .box:after,
  .ui.checkbox input:focus ~ label:after {
    color: rgba(0, 0, 0, 0.95);
  }
  .ui.checkbox input:focus ~ label {
    color: rgba(0, 0, 0, 0.95);
  }
  /*--------------
     Active
---------------*/
  .ui.checkbox input:checked ~ .box:before,
  .ui.checkbox input:checked ~ label:before {
    background: #ffffff;
    border-color: rgba(34, 36, 38, 0.45);
  }
  .ui.checkbox input:checked ~ .box:after,
  .ui.checkbox input:checked ~ label:after {
    opacity: 1;
    color: rgba(0, 0, 0, 0.95);
  }
  /*--------------
  Indeterminate
---------------*/
  .ui.checkbox input:not([type="radio"]):indeterminate ~ .box:before,
  .ui.checkbox input:not([type="radio"]):indeterminate ~ label:before {
    background: #ffffff;
    border-color: rgba(34, 36, 38, 0.45);
  }
  .ui.checkbox input:not([type="radio"]):indeterminate ~ .box:after,
  .ui.checkbox input:not([type="radio"]):indeterminate ~ label:after {
    opacity: 1;
    color: rgba(0, 0, 0, 0.95);
  }
  /*--------------
  Active Focus
---------------*/
  .ui.checkbox input:not([type="radio"]):indeterminate:focus ~ .box:before,
  .ui.checkbox input:not([type="radio"]):indeterminate:focus ~ label:before,
  .ui.checkbox input:checked:focus ~ .box:before,
  .ui.checkbox input:checked:focus ~ label:before {
    background: #ffffff;
    border-color: #96c8da;
  }
  .ui.checkbox input:not([type="radio"]):indeterminate:focus ~ .box:after,
  .ui.checkbox input:not([type="radio"]):indeterminate:focus ~ label:after,
  .ui.checkbox input:checked:focus ~ .box:after,
  .ui.checkbox input:checked:focus ~ label:after {
    color: rgba(0, 0, 0, 0.95);
  }
  /*--------------
    Read-Only
---------------*/
  .ui.read-only.checkbox,
  .ui.read-only.checkbox label {
    cursor: default;
  }
  /*--------------
     Disabled
---------------*/
  .ui.disabled.checkbox .box:after,
  .ui.disabled.checkbox label,
  .ui.checkbox input[disabled] ~ .box:after,
  .ui.checkbox input[disabled] ~ label {
    cursor: default !important;
    opacity: 0.5;
    color: #000000;
  }
  /*--------------
     Hidden
---------------*/
  /* Initialized checkbox moves input below element
 to prevent manually triggering */
  .ui.checkbox input.hidden {
    z-index: -1;
  }
  /* Selectable Label */
  .ui.checkbox input.hidden + label {
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
  }
  /*******************************
             Types
*******************************/
  /*--------------
     Radio
---------------*/
  .ui.radio.checkbox {
    min-height: 15px;
  }
  .ui.radio.checkbox .box,
  .ui.radio.checkbox label {
    padding-left: 1.85714em;
  }
  /* Box */
  .ui.radio.checkbox .box:before,
  .ui.radio.checkbox label:before {
    content: "";
    -webkit-transform: none;
    transform: none;
    width: 15px;
    height: 15px;
    border-radius: 500rem;
    top: 1px;
    left: 0px;
  }
  /* Bullet */
  .ui.radio.checkbox .box:after,
  .ui.radio.checkbox label:after {
    border: none;
    content: "" !important;
    width: 15px;
    height: 15px;
    line-height: 15px;
  }
  /* Radio Checkbox */
  .ui.radio.checkbox .box:after,
  .ui.radio.checkbox label:after {
    top: 1px;
    left: 0px;
    width: 15px;
    height: 15px;
    border-radius: 500rem;
    -webkit-transform: scale(0.46666667);
    transform: scale(0.46666667);
    background-color: rgba(0, 0, 0, 0.85);
  }
  /* Focus */
  .ui.radio.checkbox input:focus ~ .box:before,
  .ui.radio.checkbox input:focus ~ label:before {
    background-color: #ffffff;
  }
  .ui.radio.checkbox input:focus ~ .box:after,
  .ui.radio.checkbox input:focus ~ label:after {
    background-color: rgba(0, 0, 0, 0.95);
  }
  /* Indeterminate */
  .ui.radio.checkbox input:indeterminate ~ .box:after,
  .ui.radio.checkbox input:indeterminate ~ label:after {
    opacity: 0;
  }
  /* Active */
  .ui.radio.checkbox input:checked ~ .box:before,
  .ui.radio.checkbox input:checked ~ label:before {
    background-color: #ffffff;
  }
  .ui.radio.checkbox input:checked ~ .box:after,
  .ui.radio.checkbox input:checked ~ label:after {
    background-color: rgba(0, 0, 0, 0.95);
  }
  /* Active Focus */
  .ui.radio.checkbox input:focus:checked ~ .box:before,
  .ui.radio.checkbox input:focus:checked ~ label:before {
    background-color: #ffffff;
  }
  .ui.radio.checkbox input:focus:checked ~ .box:after,
  .ui.radio.checkbox input:focus:checked ~ label:after {
    background-color: rgba(0, 0, 0, 0.95);
  }
  /*--------------
     Slider
---------------*/
  .ui.slider.checkbox {
    min-height: 1.25rem;
  }
  /* Input */
  .ui.slider.checkbox input {
    width: 3.5rem;
    height: 1.25rem;
  }
  /* Label */
  .ui.slider.checkbox .box,
  .ui.slider.checkbox label {
    padding-left: 4.5rem;
    line-height: 1rem;
    color: rgba(0, 0, 0, 0.4);
  }
  /* Line */
  .ui.slider.checkbox .box:before,
  .ui.slider.checkbox label:before {
    display: block;
    position: absolute;
    content: "";
    border: none !important;
    left: 0em;
    z-index: 1;
    top: 0.4rem;
    background-color: rgba(0, 0, 0, 0.05);
    width: 3.5rem;
    height: 0.21428571rem;
    -webkit-transform: none;
    transform: none;
    border-radius: 500rem;
    transition: background 0.3s ease;
  }
  /* Handle */
  .ui.slider.checkbox .box:after,
  .ui.slider.checkbox label:after {
    background: #ffffff linear-gradient(transparent, rgba(0, 0, 0, 0.05));
    position: absolute;
    content: "" !important;
    opacity: 1;
    z-index: 2;
    border: none;
    box-shadow: 0px 2px 2px 0 rgba(34, 36, 38, 0.3),
      0px 0px 0px 1px rgba(34, 36, 38, 0.3) inset;
    width: 1.5rem;
    height: 1.5rem;
    top: -0.25rem;
    left: 0em;
    -webkit-transform: none;
    transform: none;
    border-radius: 500rem;
    transition: left 0.3s ease;
  }
  /* Focus */
  .ui.slider.checkbox input:focus ~ .box:before,
  .ui.slider.checkbox input:focus ~ label:before {
    background-color: rgba(0, 0, 0, 0.15);
    border: none;
  }
  /* Hover */
  .ui.slider.checkbox .box:hover,
  .ui.slider.checkbox label:hover {
    color: rgba(0, 0, 0, 0.8);
  }
  .ui.slider.checkbox .box:hover::before,
  .ui.slider.checkbox label:hover::before {
    background: rgba(0, 0, 0, 0.15);
  }
  /* Active */
  .ui.slider.checkbox input:checked ~ .box,
  .ui.slider.checkbox input:checked ~ label {
    color: rgba(0, 0, 0, 0.95) !important;
  }
  .ui.slider.checkbox input:checked ~ .box:before,
  .ui.slider.checkbox input:checked ~ label:before {
    background-color: #545454 !important;
  }
  .ui.slider.checkbox input:checked ~ .box:after,
  .ui.slider.checkbox input:checked ~ label:after {
    left: 2rem;
  }
  /* Active Focus */
  .ui.slider.checkbox input:focus:checked ~ .box,
  .ui.slider.checkbox input:focus:checked ~ label {
    color: rgba(0, 0, 0, 0.95) !important;
  }
  .ui.slider.checkbox input:focus:checked ~ .box:before,
  .ui.slider.checkbox input:focus:checked ~ label:before {
    background-color: #000000 !important;
  }
  /*--------------
     Toggle
---------------*/
  .ui.toggle.checkbox {
    min-height: 1.5rem;
  }
  /* Input */
  .ui.toggle.checkbox input {
    width: 3.5rem;
    height: 1.5rem;
  }
  /* Label */
  .ui.toggle.checkbox .box,
  .ui.toggle.checkbox label {
    min-height: 1.5rem;
    padding-left: 4.5rem;
    color: rgba(0, 0, 0, 0.85);
  }
  .ui.toggle.checkbox label {
    padding-top: 0.15em;
  }
  /* Switch */
  .ui.toggle.checkbox .box:before,
  .ui.toggle.checkbox label:before {
    display: block;
    position: absolute;
    content: "";
    z-index: 1;
    -webkit-transform: none;
    transform: none;
    border: none;
    top: 0rem;
    background: rgba(0, 0, 0, 0.05);
    box-shadow: none;
    width: 3.5rem;
    height: 1.5rem;
    border-radius: 500rem;
  }
  /* Handle */
  .ui.toggle.checkbox .box:after,
  .ui.toggle.checkbox label:after {
    background: #ffffff linear-gradient(transparent, rgba(0, 0, 0, 0.05));
    position: absolute;
    content: "" !important;
    opacity: 1;
    z-index: 2;
    border: none;
    box-shadow: 0px 2px 2px 0 rgba(34, 36, 38, 0.3),
      0px 0px 0px 1px rgba(34, 36, 38, 0.3) inset;
    width: 1.5rem;
    height: 1.5rem;
    top: 0rem;
    left: 0em;
    border-radius: 500rem;
    transition: background 0.3s ease, left 0.3s ease;
  }
  .ui.toggle.checkbox input ~ .box:after,
  .ui.toggle.checkbox input ~ label:after {
    left: -0.05rem;
    box-shadow: 0px 2px 2px 0 rgba(34, 36, 38, 0.3),
      0px 0px 0px 1px rgba(34, 36, 38, 0.3) inset;
  }
  /* Focus */
  .ui.toggle.checkbox input:focus ~ .box:before,
  .ui.toggle.checkbox input:focus ~ label:before {
    background-color: rgba(0, 0, 0, 0.15);
    border: none;
  }
  /* Hover */
  .ui.toggle.checkbox .box:hover::before,
  .ui.toggle.checkbox label:hover::before {
    background-color: rgba(0, 0, 0, 0.15);
    border: none;
  }
  /* Active */
  .ui.toggle.checkbox input:checked ~ .box,
  .ui.toggle.checkbox input:checked ~ label {
    color: rgba(0, 0, 0, 0.95) !important;
  }
  .ui.toggle.checkbox input:checked ~ .box:before,
  .ui.toggle.checkbox input:checked ~ label:before {
    background-color: #1163a1 !important;
  }
  .ui.toggle.checkbox input:checked ~ .box:after,
  .ui.toggle.checkbox input:checked ~ label:after {
    left: 2.15rem;
    box-shadow: 0px 2px 2px 0 rgba(34, 36, 38, 0.3),
      0px 0px 0px 1px rgba(34, 36, 38, 0.3) inset;
  }
  /* Active Focus */
  .ui.toggle.checkbox input:focus:checked ~ .box,
  .ui.toggle.checkbox input:focus:checked ~ label {
    color: rgba(0, 0, 0, 0.95) !important;
  }
  .ui.toggle.checkbox input:focus:checked ~ .box:before,
  .ui.toggle.checkbox input:focus:checked ~ label:before {
    background-color: #024e87 !important;
  }
  /*******************************
            Variations
*******************************/
  /*--------------
     Fitted
---------------*/
  .ui.fitted.checkbox .box,
  .ui.fitted.checkbox label {
    padding-left: 0em !important;
  }
  .ui.fitted.toggle.checkbox,
  .ui.fitted.toggle.checkbox {
    width: 3.5rem;
  }
  .ui.fitted.slider.checkbox,
  .ui.fitted.slider.checkbox {
    width: 3.5rem;
  }
  /*******************************
         Theme Overrides
*******************************/
  @font-face {
    font-family: "Checkbox";
    src: url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMg8SBD8AAAC8AAAAYGNtYXAYVtCJAAABHAAAAFRnYXNwAAAAEAAAAXAAAAAIZ2x5Zn4huwUAAAF4AAABYGhlYWQGPe1ZAAAC2AAAADZoaGVhB30DyAAAAxAAAAAkaG10eBBKAEUAAAM0AAAAHGxvY2EAmgESAAADUAAAABBtYXhwAAkALwAAA2AAAAAgbmFtZSC8IugAAAOAAAABknBvc3QAAwAAAAAFFAAAACAAAwMTAZAABQAAApkCzAAAAI8CmQLMAAAB6wAzAQkAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADoAgPA/8AAQAPAAEAAAAABAAAAAAAAAAAAAAAgAAAAAAADAAAAAwAAABwAAQADAAAAHAADAAEAAAAcAAQAOAAAAAoACAACAAIAAQAg6AL//f//AAAAAAAg6AD//f//AAH/4xgEAAMAAQAAAAAAAAAAAAAAAQAB//8ADwABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQAAAAAAAAAAAAIAADc5AQAAAAABAEUAUQO7AvgAGgAAARQHAQYjIicBJjU0PwE2MzIfAQE2MzIfARYVA7sQ/hQQFhcQ/uMQEE4QFxcQqAF2EBcXEE4QAnMWEP4UEBABHRAXFhBOEBCoAXcQEE4QFwAAAAABAAABbgMlAkkAFAAAARUUBwYjISInJj0BNDc2MyEyFxYVAyUQEBf9SRcQEBAQFwK3FxAQAhJtFxAQEBAXbRcQEBAQFwAAAAABAAAASQMlA24ALAAAARUUBwYrARUUBwYrASInJj0BIyInJj0BNDc2OwE1NDc2OwEyFxYdATMyFxYVAyUQEBfuEBAXbhYQEO4XEBAQEBfuEBAWbhcQEO4XEBACEm0XEBDuFxAQEBAX7hAQF20XEBDuFxAQEBAX7hAQFwAAAQAAAAIAAHRSzT9fDzz1AAsEAAAAAADRsdR3AAAAANGx1HcAAAAAA7sDbgAAAAgAAgAAAAAAAAABAAADwP/AAAAEAAAAAAADuwABAAAAAAAAAAAAAAAAAAAABwQAAAAAAAAAAAAAAAIAAAAEAABFAyUAAAMlAAAAAAAAAAoAFAAeAE4AcgCwAAEAAAAHAC0AAQAAAAAAAgAAAAAAAAAAAAAAAAAAAAAAAAAOAK4AAQAAAAAAAQAIAAAAAQAAAAAAAgAHAGkAAQAAAAAAAwAIADkAAQAAAAAABAAIAH4AAQAAAAAABQALABgAAQAAAAAABgAIAFEAAQAAAAAACgAaAJYAAwABBAkAAQAQAAgAAwABBAkAAgAOAHAAAwABBAkAAwAQAEEAAwABBAkABAAQAIYAAwABBAkABQAWACMAAwABBAkABgAQAFkAAwABBAkACgA0ALBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhWZXJzaW9uIDIuMABWAGUAcgBzAGkAbwBuACAAMgAuADBDaGVja2JveABDAGgAZQBjAGsAYgBvAHhDaGVja2JveABDAGgAZQBjAGsAYgBvAHhSZWd1bGFyAFIAZQBnAHUAbABhAHJDaGVja2JveABDAGgAZQBjAGsAYgBvAHhGb250IGdlbmVyYXRlZCBieSBJY29Nb29uLgBGAG8AbgB0ACAAZwBlAG4AZQByAGEAdABlAGQAIABiAHkAIABJAGMAbwBNAG8AbwBuAC4AAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA)
      format("truetype");
  }
  /* Checkmark */
  .ui.checkbox label:after,
  .ui.checkbox .box:after {
    font-family: "Checkbox";
  }
  /* Checked */
  .ui.checkbox input:checked ~ .box:after,
  .ui.checkbox input:checked ~ label:after {
    content: "\e800";
  }
  /* Indeterminate */
  .ui.checkbox input:indeterminate ~ .box:after,
  .ui.checkbox input:indeterminate ~ label:after {
    font-size: 12px;
    content: "\e801";
  }
`;
